/**
 * @name: dictionary.js
 * @description: 常用下拉框数据字段
 * @author: 温永江
 * @create: 2020/07/22 14:23:44
 * @update: 2020/07/22 14:23:44
 */

// export const billStatusList = {
//   "-1": "已关闭",
//   "1": "未完成",
//   "2": "已完成"
// }

// 通用禁用启用状态
export const status = {
  0: '禁用',
  1: '启用'
};

// 经营状态
export const businessStatus = {
  '-1': '全部',
  0: '冻结中',
  2: '停业中',
  1: '经营中'
};

// 门店类型
export const shopType = {
  1: '总店',
  0: '分店'
};

// 标签类型
export const labelType = {
  '': '全部',
  '01': '经销商标签',
  '02': '客户标签',
  '03': '门店标签'
};

// 审核状态
export const auditStatus = {
  0: '未审核',
  1: '已审核'
};

// 客户状态
export const customerStatus = {
  '-1': '全部',
  0: '冻结中',
  1: '经营中',
  2: '停业中'
};

// 业务员状态
export const salemanStatus = {
  '-1': '全部',
  0: '已禁用',
  1: '已启用',
  2: '已离职'
};
